import React, { Fragment, useState } from 'react';
import { generateId } from '@adp-wfn/mdf-core';
import { SdfBusyIndicator } from '@waypoint/react-components';
import { BusyIndicator } from '@synerg/vdl-react-components';
import { resolveAriaProperty } from '../util/resolveAriaProperty';

export type IMDFBusyIndicatorSize = 'sm' | 'md' | 'lg' | 'xl';

export interface IMDFBusyIndicatorProps {
  ariaLabel?: string;
  'aria-label'?: string;
  className?: string;
  fullScreen?: boolean;
  id?: string;
  overlay?: boolean;
  size?: IMDFBusyIndicatorSize;
  style?: Record<string, any>;
}

export const MDFBusyIndicator = (props: IMDFBusyIndicatorProps) => {
  const { fullScreen, size = 'md', overlay } = props;
  const [id] = useState(props.id ?? generateId('MDFBusyIndicator'));
  const ariaLabel = resolveAriaProperty(MDFBusyIndicator.displayName, 'aria-label', 'ariaLabel', props);

  const isADPUnified = !window['isLegacyAppShell'];

  return (
    <Fragment>
      {
        isADPUnified ?
          <SdfBusyIndicator
            size={size}
            overlay={overlay}
            fullscreen={fullScreen}
            labelAria={ariaLabel}
            id={id}
          /> :
          <BusyIndicator
            size={size}
            overlay={overlay}
            fullScreen={fullScreen}
            className={props.className}
            aria-label={ariaLabel}
            style={props.style}
          />
      }
    </Fragment>
  );
};

MDFBusyIndicator.displayName = 'MDFBusyIndicator';
